import { render } from "./Align.vue?vue&type=template&id=2c39e9ec"
import script from "./Align.vue?vue&type=script&lang=js"
export * from "./Align.vue?vue&type=script&lang=js"
script.render = render

export default script